import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '@/utils/constants';
import {getDefaultPieFormatting} from '../../charts/pie';

interface IExternalFundingProps {
	baseline: any[];
}

const ExternalFunding = ({baseline}: IExternalFundingProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        const success = baseline.filter((submission: any) => submission.question20 === 'Item 1').length;
        const unSuccess = baseline.filter((submission: any) => submission.question20 === 'Item 2').length;

        const data = [
            {
                name: 'Yes',
                y: success,
                color: COLORS.blue,
            },
            {
                name: 'No',
                y: unSuccess,
                color: COLORS.yellow,
            },
        ];
        const title = '% of entrepreneurs who requested funds before the program';
        const dashboardOptions: any = getDefaultPieFormatting(title, data);

        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default ExternalFunding;
